import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

interface StateApiResponse {
  id: number;
  name: string;
  abbreviation: string;
}

export interface StateOption {
  value: string;
  label: string;
}

const STORAGE_KEY = 'dms_states';

@Injectable({ providedIn: 'root' })
export class StateService {
  private readonly statesUrl = `${environment.apiUrl}/v1/states`;

  constructor(private http: HttpClient) {}

  /** Fetches states from API and stores in localStorage. Called once at app startup. */
  load(): Observable<StateOption[]> {
    return this.http.get<StateApiResponse[]>(this.statesUrl).pipe(
      map(states => states.map(s => ({ value: s.abbreviation, label: s.name }))),
      tap(states => {
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(states));
        } catch {
          // ignore storage errors
        }
      })
    );
  }

  /** Returns cached states from localStorage. */
  getStates(): StateOption[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw) as StateOption[];
    } catch {
      // ignore corrupt data
    }
    return [];
  }
}
